import {
  Plane,
  Moon,
  MapPin,
  Star,
  Waves,
  Wifi,
  Wind,
  ParkingCircle,
  Utensils,
  X,
  Check,
  ChevronLeft,
  ChevronRight,
  ChevronDown,
  ArrowUpDown,
  Bus,
  Ticket,
  Crown,
  ShieldCheck,
  Filter,
  RotateCcw,
  Image as ImageIcon,
} from "lucide-react"

export const SOURCES = {
  teztour: { name: "TezTour", initials: "TT", color: "#2E86DE" },
  coral: { name: "Coral Travel", initials: "CT", color: "#FF6B3D" },
  anex: { name: "Anex Tour", initials: "AT", color: "#7C5CFC" },
  voyage: { name: "Voyage", initials: "VY", color: "#16A87E" },
}

export const RAW_RESPONSE = {
  status: "success",
  token: "aB3dEfGh1K2mN4pQ",
  missing_price_ids: [],
  tours: [
    {
      price_id: 918273,
      source_id: "teztour",
      hotel_id: 4521,
      hotel_name: "LITSA EFI APARTMENTS",
      star_name: "2*",
      group_hotel_id: 1187,
      region_name: "Crete-Heraklion",
      resort_name: "Stalida",
      date_entry: "01.08.2026",
      date_out: "08.08.2026",
      nights: 7,
      food_name: "Room Rates",
      type_room_name: "Apartment 2-3 / 2adl",
      room_desc_id: 33021,
      room_description: "Cozy apartment with kitchenette, located 200m from the beach.",
      room_photos: [
        "https://images.unsplash.com/photo-1522771739844-6a9f6d5f14af?q=80&w=800&auto=format&fit=crop",
        "https://images.unsplash.com/photo-1595576508898-0ad5c879a061?q=80&w=800&auto=format&fit=crop",
      ],
      price: 325.0,
      currency: "EUR",
      package_info: "Charter flight + transfer included",
      on_request: false,
      guaranteed: true,
      has_transport: true,
      has_transfer: true,
      transfer_terminal_name: "Heraklion Airport",
      terminal_name: "Chisinau",
      transport_type_name: "Charter",
      hotel_details: {
        services: ["pool", "wifi", "air_conditioning", "parking"],
        photos: [
          "https://images.unsplash.com/photo-1571003123894-1f0594d2b5d9?q=80&w=800&auto=format&fit=crop",
          "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?q=80&w=800&auto=format&fit=crop",
          "https://images.unsplash.com/photo-1602002418082-a4443e081dd1?q=80&w=800&auto=format&fit=crop",
        ],
      },
    },
    {
      price_id: 918275,
      source_id: "coral",
      hotel_id: 4521,
      hotel_name: "LITSA EFI APARTMENTS",
      star_name: "2*",
      group_hotel_id: 1187,
      region_name: "Crete-Heraklion",
      resort_name: "Stalida",
      date_entry: "01.08.2026",
      date_out: "08.08.2026",
      nights: 7,
      food_name: "Room Rates",
      type_room_name: "Apartment 2-3 / 2adl",
      room_desc_id: 33021,
      room_description: "Cozy apartment with kitchenette, located 200m from the beach.",
      room_photos: [
        "https://images.unsplash.com/photo-1522771739844-6a9f6d5f14af?q=80&w=800&auto=format&fit=crop",
        "https://images.unsplash.com/photo-1595576508898-0ad5c879a061?q=80&w=800&auto=format&fit=crop",
      ],
      price: 339.0,
      currency: "EUR",
      package_info: "Charter flight + transfer included",
      on_request: false,
      guaranteed: false,
      has_transport: true,
      has_transfer: true,
      transfer_terminal_name: "Heraklion Airport",
      terminal_name: "Chisinau",
      transport_type_name: "Charter",
      hotel_details: {
        services: ["pool", "wifi", "air_conditioning", "parking"],
        photos: [
          "https://images.unsplash.com/photo-1571003123894-1f0594d2b5d9?q=80&w=800&auto=format&fit=crop",
          "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?q=80&w=800&auto=format&fit=crop",
          "https://images.unsplash.com/photo-1602002418082-a4443e081dd1?q=80&w=800&auto=format&fit=crop",
        ],
      },
    },
    {
      price_id: 918276,
      source_id: "anex",
      hotel_id: 4521,
      hotel_name: "LITSA EFI APARTMENTS",
      star_name: "2*",
      group_hotel_id: 1187,
      region_name: "Crete-Heraklion",
      resort_name: "Stalida",
      date_entry: "01.08.2026",
      date_out: "08.08.2026",
      nights: 7,
      food_name: "Room Rates",
      type_room_name: "Apartment 2-3 / 2adl",
      room_desc_id: 33021,
      room_description: "Cozy apartment with kitchenette, located 200m from the beach.",
      room_photos: [
        "https://images.unsplash.com/photo-1522771739844-6a9f6d5f14af?q=80&w=800&auto=format&fit=crop",
        "https://images.unsplash.com/photo-1595576508898-0ad5c879a061?q=80&w=800&auto=format&fit=crop",
      ],
      price: 351.0,
      currency: "EUR",
      package_info: "Charter flight + transfer included",
      on_request: false,
      guaranteed: false,
      has_transport: true,
      has_transfer: true,
      transfer_terminal_name: "Heraklion Airport",
      terminal_name: "Chisinau",
      transport_type_name: "Charter",
      hotel_details: {
        services: ["pool", "wifi", "air_conditioning", "parking"],
        photos: [
          "https://images.unsplash.com/photo-1571003123894-1f0594d2b5d9?q=80&w=800&auto=format&fit=crop",
          "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?q=80&w=800&auto=format&fit=crop",
          "https://images.unsplash.com/photo-1602002418082-a4443e081dd1?q=80&w=800&auto=format&fit=crop",
        ],
      },
    },

    {
      price_id: 918274,
      source_id: "teztour",
      hotel_id: 4521,
      hotel_name: "LITSA EFI APARTMENTS",
      star_name: "2*",
      group_hotel_id: 1187,
      region_name: "Crete-Heraklion",
      resort_name: "Stalida",
      date_entry: "01.08.2026",
      date_out: "08.08.2026",
      nights: 7,
      food_name: "Bed and Breakfast",
      type_room_name: "Apartment 2-3 / 2adl",
      room_desc_id: 33021,
      room_description: "Cozy apartment with kitchenette, located 200m from the beach.",
      room_photos: [
        "https://images.unsplash.com/photo-1522771739844-6a9f6d5f14af?q=80&w=800&auto=format&fit=crop",
      ],
      price: 426.0,
      currency: "EUR",
      package_info: "Charter flight + transfer included",
      on_request: false,
      guaranteed: false,
      has_transport: true,
      has_transfer: true,
      transfer_terminal_name: "Heraklion Airport",
      terminal_name: "Chisinau",
      transport_type_name: "Charter",
      hotel_details: {
        services: ["pool", "wifi", "air_conditioning", "parking"],
        photos: [
          "https://images.unsplash.com/photo-1571003123894-1f0594d2b5d9?q=80&w=800&auto=format&fit=crop",
          "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?q=80&w=800&auto=format&fit=crop",
          "https://images.unsplash.com/photo-1602002418082-a4443e081dd1?q=80&w=800&auto=format&fit=crop",
        ],
      },
    },
    {
      price_id: 918277,
      source_id: "voyage",
      hotel_id: 4521,
      hotel_name: "LITSA EFI APARTMENTS",
      star_name: "2*",
      group_hotel_id: 1187,
      region_name: "Crete-Heraklion",
      resort_name: "Stalida",
      date_entry: "01.08.2026",
      date_out: "08.08.2026",
      nights: 7,
      food_name: "Bed and Breakfast",
      type_room_name: "Apartment 2-3 / 2adl",
      room_desc_id: 33021,
      room_description: "Cozy apartment with kitchenette, located 200m from the beach.",
      room_photos: [
        "https://images.unsplash.com/photo-1522771739844-6a9f6d5f14af?q=80&w=800&auto=format&fit=crop",
      ],
      price: 415.0,
      currency: "EUR",
      package_info: "Charter flight + transfer included",
      on_request: false,
      guaranteed: true,
      has_transport: true,
      has_transfer: true,
      transfer_terminal_name: "Heraklion Airport",
      terminal_name: "Chisinau",
      transport_type_name: "Charter",
      hotel_details: {
        services: ["pool", "wifi", "air_conditioning", "parking"],
        photos: [
          "https://images.unsplash.com/photo-1571003123894-1f0594d2b5d9?q=80&w=800&auto=format&fit=crop",
          "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?q=80&w=800&auto=format&fit=crop",
          "https://images.unsplash.com/photo-1602002418082-a4443e081dd1?q=80&w=800&auto=format&fit=crop",
        ],
      },
    },
    {
      price_id: 918278,
      source_id: "coral",
      hotel_id: 4521,
      hotel_name: "LITSA EFI APARTMENTS",
      star_name: "2*",
      group_hotel_id: 1187,
      region_name: "Crete-Heraklion",
      resort_name: "Stalida",
      date_entry: "01.08.2026",
      date_out: "08.08.2026",
      nights: 7,
      food_name: "Bed and Breakfast",
      type_room_name: "Apartment 2-3 / 2adl",
      room_desc_id: 33021,
      room_description: "Cozy apartment with kitchenette, located 200m from the beach.",
      room_photos: [
        "https://images.unsplash.com/photo-1522771739844-6a9f6d5f14af?q=80&w=800&auto=format&fit=crop",
      ],
      price: 440.0,
      currency: "EUR",
      package_info: "Charter flight + transfer included",
      on_request: false,
      guaranteed: false,
      has_transport: true,
      has_transfer: true,
      transfer_terminal_name: "Heraklion Airport",
      terminal_name: "Chisinau",
      transport_type_name: "Charter",
      hotel_details: {
        services: ["pool", "wifi", "air_conditioning", "parking"],
        photos: [
          "https://images.unsplash.com/photo-1571003123894-1f0594d2b5d9?q=80&w=800&auto=format&fit=crop",
          "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?q=80&w=800&auto=format&fit=crop",
          "https://images.unsplash.com/photo-1602002418082-a4443e081dd1?q=80&w=800&auto=format&fit=crop",
        ],
      },
    },

    {
      price_id: 918290,
      source_id: "anex",
      hotel_id: 6042,
      hotel_name: "CRETA MARIS BEACH RESORT",
      star_name: "5*",
      group_hotel_id: 1290,
      region_name: "Crete-Heraklion",
      resort_name: "Hersonissos",
      date_entry: "02.08.2026",
      date_out: "09.08.2026",
      nights: 7,
      food_name: "All Inclusive",
      type_room_name: "Deluxe Bungalow / 2adl",
      room_desc_id: 44110,
      room_description:
        "Spacious bungalow set in landscaped gardens, short walk to the private beach.",
      room_photos: [
        "https://images.unsplash.com/photo-1582719508461-905c673771fd?q=80&w=800&auto=format&fit=crop",
        "https://images.unsplash.com/photo-1611892440504-42a792e24d32?q=80&w=800&auto=format&fit=crop",
      ],
      price: 1180.0,
      currency: "EUR",
      package_info: "Charter flight + transfer included",
      on_request: true,
      guaranteed: false,
      has_transport: true,
      has_transfer: true,
      transfer_terminal_name: "Heraklion Airport",
      terminal_name: "Chisinau",
      transport_type_name: "Charter",
      hotel_details: {
        services: ["pool", "wifi", "air_conditioning", "parking"],
        photos: [
          "https://images.unsplash.com/photo-1571003123894-1f0594d2b5d9?q=80&w=800&auto=format&fit=crop",
          "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?q=80&w=800&auto=format&fit=crop",
          "https://images.unsplash.com/photo-1602002418082-a4443e081dd1?q=80&w=800&auto=format&fit=crop",
        ],
      },
    },
    {
      price_id: 918291,
      source_id: "coral",
      hotel_id: 6042,
      hotel_name: "CRETA MARIS BEACH RESORT",
      star_name: "5*",
      group_hotel_id: 1290,
      region_name: "Crete-Heraklion",
      resort_name: "Hersonissos",
      date_entry: "02.08.2026",
      date_out: "09.08.2026",
      nights: 7,
      food_name: "All Inclusive",
      type_room_name: "Deluxe Bungalow / 2adl",
      room_desc_id: 44110,
      room_description:
        "Spacious bungalow set in landscaped gardens, short walk to the private beach.",
      room_photos: [
        "https://images.unsplash.com/photo-1582719508461-905c673771fd?q=80&w=800&auto=format&fit=crop",
        "https://images.unsplash.com/photo-1611892440504-42a792e24d32?q=80&w=800&auto=format&fit=crop",
      ],
      price: 1210.0,
      currency: "EUR",
      package_info: "Charter flight + transfer included",
      on_request: false,
      guaranteed: true,
      has_transport: true,
      has_transfer: true,
      transfer_terminal_name: "Heraklion Airport",
      terminal_name: "Chisinau",
      transport_type_name: "Charter",
      hotel_details: {
        services: ["pool", "wifi", "air_conditioning", "parking"],
        photos: [
          "https://images.unsplash.com/photo-1571003123894-1f0594d2b5d9?q=80&w=800&auto=format&fit=crop",
          "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?q=80&w=800&auto=format&fit=crop",
          "https://images.unsplash.com/photo-1602002418082-a4443e081dd1?q=80&w=800&auto=format&fit=crop",
        ],
      },
    },

    {
      price_id: 918305,
      source_id: "teztour",
      hotel_id: 7310,
      hotel_name: "GOUVES BLUE APARTMENTS",
      star_name: "3*",
      group_hotel_id: 1401,
      region_name: "Crete-Heraklion",
      resort_name: "Gouves",
      date_entry: "03.08.2026",
      date_out: "10.08.2026",
      nights: 7,
      food_name: "Bed and Breakfast",
      type_room_name: "Studio 2adl",
      room_desc_id: 55210,
      room_description: "Quiet studios around a shared pool, 5 minutes from the marina.",
      room_photos: [],
      price: 398.0,
      currency: "EUR",
      package_info: "Charter flight + transfer included",
      on_request: false,
      guaranteed: false,
      has_transport: true,
      has_transfer: true,
      transfer_terminal_name: "Heraklion Airport",
      terminal_name: "Chisinau",
      transport_type_name: "Charter",
      hotel_details: { services: ["pool", "wifi", "parking"], photos: [] },
    },
    {
      price_id: 918306,
      source_id: "anex",
      hotel_id: 7310,
      hotel_name: "GOUVES BLUE APARTMENTS",
      star_name: "3*",
      group_hotel_id: 1401,
      region_name: "Crete-Heraklion",
      resort_name: "Gouves",
      date_entry: "03.08.2026",
      date_out: "10.08.2026",
      nights: 7,
      food_name: "Half Board",
      type_room_name: "Studio 2adl",
      room_desc_id: 55210,
      room_description: "Quiet studios around a shared pool, 5 minutes from the marina.",
      room_photos: [],
      price: 452.0,
      currency: "EUR",
      package_info: "Charter flight + transfer included",
      on_request: false,
      guaranteed: false,
      has_transport: true,
      has_transfer: true,
      transfer_terminal_name: "Heraklion Airport",
      terminal_name: "Chisinau",
      transport_type_name: "Charter",
      hotel_details: { services: ["pool", "wifi", "parking"], photos: [] },
    },
    {
      price_id: 918312,
      source_id: "voyage",
      hotel_id: 8110,
      hotel_name: "MALIA BAY VIEW",
      star_name: "4*",
      group_hotel_id: 1502,
      region_name: "Crete-Heraklion",
      resort_name: "Malia",
      date_entry: "04.08.2026",
      date_out: "11.08.2026",
      nights: 7,
      food_name: "All Inclusive",
      type_room_name: "Sea View Room 2adl",
      room_desc_id: 66310,
      room_description: "Beachfront hotel with a lively strip of bars and shops nearby.",
      room_photos: [],
      price: 610.0,
      currency: "EUR",
      package_info: "Charter flight + transfer included",
      on_request: false,
      guaranteed: false,
      has_transport: true,
      has_transfer: true,
      transfer_terminal_name: "Heraklion Airport",
      terminal_name: "Chisinau",
      transport_type_name: "Charter",
      hotel_details: { services: ["pool", "wifi", "air_conditioning"], photos: [] },
    },
    {
      price_id: 918320,
      source_id: "teztour",
      hotel_id: 9210,
      hotel_name: "RETHYMNO PALACE",
      star_name: "4*",
      group_hotel_id: 1610,
      region_name: "Crete-Rethymno",
      resort_name: "Rethymno",
      date_entry: "05.08.2026",
      date_out: "12.08.2026",
      nights: 7,
      food_name: "Half Board",
      type_room_name: "Standard Room 2adl",
      room_desc_id: 77410,
      room_description: "A short walk from the old town's Venetian harbour.",
      room_photos: [],
      price: 540.0,
      currency: "EUR",
      package_info: "Charter flight + transfer included",
      on_request: false,
      guaranteed: true,
      has_transport: true,
      has_transfer: true,
      transfer_terminal_name: "Chania Airport",
      terminal_name: "Chisinau",
      transport_type_name: "Charter",
      hotel_details: { services: ["wifi", "air_conditioning"], photos: [] },
    },
    {
      price_id: 918321,
      source_id: "coral",
      hotel_id: 9310,
      hotel_name: "AGIOS NIKOLAOS RESORT",
      star_name: "4*",
      group_hotel_id: 1611,
      region_name: "Crete-Lassithi",
      resort_name: "Agios Nikolaos",
      date_entry: "05.08.2026",
      date_out: "12.08.2026",
      nights: 7,
      food_name: "Bed and Breakfast",
      type_room_name: "Standard Room 2adl",
      room_desc_id: 77510,
      room_description: "Overlooks the lake, close to the marina and old town.",
      room_photos: [],
      price: 495.0,
      currency: "EUR",
      package_info: "Charter flight + transfer included",
      on_request: false,
      guaranteed: false,
      has_transport: true,
      has_transfer: true,
      transfer_terminal_name: "Heraklion Airport",
      terminal_name: "Chisinau",
      transport_type_name: "Charter",
      hotel_details: { services: ["wifi", "parking"], photos: [] },
    },
    {
      price_id: 918322,
      source_id: "anex",
      hotel_id: 9410,
      hotel_name: "ELOUNDA GARDENS",
      star_name: "5*",
      group_hotel_id: 1612,
      region_name: "Crete-Lassithi",
      resort_name: "Elounda",
      date_entry: "06.08.2026",
      date_out: "13.08.2026",
      nights: 7,
      food_name: "All Inclusive",
      type_room_name: "Garden Bungalow 2adl",
      room_desc_id: 77610,
      room_description: "Terraced gardens leading down to a private cove.",
      room_photos: [],
      price: 890.0,
      currency: "EUR",
      package_info: "Charter flight + transfer included",
      on_request: false,
      guaranteed: true,
      has_transport: true,
      has_transfer: true,
      transfer_terminal_name: "Heraklion Airport",
      terminal_name: "Chisinau",
      transport_type_name: "Charter",
      hotel_details: { services: ["pool", "wifi", "parking"], photos: [] },
    },
  ],
}

export const SERVICE_ICON = {
  pool: Waves,
  wifi: Wifi,
  air_conditioning: Wind,
  parking: ParkingCircle,
}
export const SERVICE_LABEL = {
  pool: "Pool",
  wifi: "Wi-Fi",
  air_conditioning: "AC",
  parking: "Parking",
}
